var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFerroU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7663 63.4397C51.7778 63.4397 52.5696 63.8659 53.1418 64.7183C53.7139 65.5651 54 66.7282 54 68.2075C54 69.7308 53.7037 70.9103 53.1111 71.7462C52.5236 72.5821 51.7216 73 50.705 73C49.6986 73 48.9093 72.6068 48.3372 71.8204H48.1762L47.7854 72.835H46V60H48.3372V62.986C48.3372 63.3655 48.3065 63.9731 48.2452 64.809H48.3372C48.8838 63.8962 49.6935 63.4397 50.7663 63.4397ZM50.0153 65.4524C49.4381 65.4524 49.0166 65.6449 48.751 66.0298C48.4853 66.4093 48.3474 67.0389 48.3372 67.9188V68.191C48.3372 69.1808 48.4725 69.8902 48.7433 70.3192C49.0192 70.7481 49.4534 70.9626 50.046 70.9626C50.5262 70.9626 50.9068 70.7261 51.1877 70.2532C51.4738 69.7747 51.6169 69.0819 51.6169 68.1745C51.6169 67.2671 51.4738 66.588 51.1877 66.1371C50.9017 65.6806 50.5109 65.4524 50.0153 65.4524Z",
    fill: "#005AE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2909 49.8277L18.8175 48.5185H18.7533C18.3414 49.0755 17.9161 49.4631 17.4774 49.6813C17.0441 49.8938 16.4771 50 15.7763 50C14.9151 50 14.2357 49.7359 13.7382 49.2076C13.2461 48.6793 13 47.9271 13 46.9509C13 45.9288 13.3317 45.1766 13.995 44.6942C14.6637 44.2061 15.6693 43.9363 17.012 43.8846L18.5687 43.8329V43.4109C18.5687 42.4347 18.1033 41.9466 17.1725 41.9466C16.4557 41.9466 15.6132 42.1792 14.6449 42.6443L13.8345 40.8699C14.8669 40.29 16.0117 40 17.2688 40C18.4724 40 19.3952 40.2814 20.0371 40.8441C20.679 41.4068 21 42.2624 21 43.4109V49.8277H19.2909ZM18.5687 45.3661L17.6219 45.4005C16.9104 45.4235 16.3808 45.5613 16.0331 45.814C15.6854 46.0666 15.5115 46.4513 15.5115 46.9681C15.5115 47.7089 15.9074 48.0792 16.6991 48.0792C17.2661 48.0792 17.7182 47.9041 18.0552 47.5538C18.3975 47.2036 18.5687 46.7384 18.5687 46.1585V45.3661Z",
    fill: "#008746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32V54.5H73V32",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0736 50C81.3579 50 80 48.352 80 45.0561C80 43.4167 80.3694 42.1657 81.1081 41.3028C81.8469 40.4343 82.9056 40 84.2843 40C85.2936 40 86.1988 40.2186 87 40.6557L86.2977 42.692C85.9231 42.5252 85.5745 42.39 85.252 42.2865C84.9294 42.1772 84.6068 42.1225 84.2843 42.1225C83.0461 42.1225 82.427 43.0946 82.427 45.0388C82.427 46.9255 83.0461 47.8689 84.2843 47.8689C84.7421 47.8689 85.1661 47.8027 85.5563 47.6704C85.9465 47.5324 86.3367 47.3195 86.7269 47.0319V49.2839C86.3419 49.5542 85.9517 49.7412 85.5563 49.8447C85.1661 49.9482 84.6719 50 84.0736 50Z",
    fill: "#E40E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerroU);
export default __webpack_public_path__ + "static/media/ferro_U.e5aa84eb0a9d689360acd0e244bebb93.svg";
export { ForwardRef as ReactComponent };